import qs from 'qs'
import axios from './../index'

/**
 * @description 区域经销列表
 * http://192.168.2.177:3000/mock/21/ctrlmarketing/load-ctrlmarketing-list
 * @author cc
 * @date 2020-09-11
 * @export
 */
export function loadCtrlmarketingList (params) {
  return axios.post('/ctrlmarketing/load-ctrlmarketing-list', qs.stringify(params))
}
